export default {
  name: '参展流程',
  item1: '1.提交公司营业执照',
  item2: '2.提交产品图片及名称',
  item3: '3.接收展会介绍文件及展位图',
  item4: '4.提交展位申请表/签订展位合同',
  item5: '5.支付合同展位订金',
  item6: '6.准备参展'
}
